import { toast } from 'react-toastify';
export const showNotification = ({ type, title }: any) => {
  if (type == 'success') {
    toast.success(title, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'custom-toast',
      
      
    });
  } else if (type == 'info') {
    toast.info(title, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'custom-toast',
    });
  } else if (type == 'error') {
    toast.error(title, {
      position: toast.POSITION.TOP_RIGHT,
      className: 'custom-toast',
    });
  }
};
